import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FiltersDesktop from "../../components/TableFilters/FiltersDesktop";
import FiltersMobile from "../../components/TableFilters/FiltersMobile";
import useTransactionsPaidHistory from "../../hooks/useTransactionsPaidHistory";
import { useFilterState } from "../../state/filters";
import { isMobile } from "../../utils";
import { useCompanyPageTitle } from "../../state/selectedPaymentConfiguration";
import { filtersDesktopInputs, filtersMobileInputs } from "./utils";

import AsyncResultsWrapper from "../../components/AsyncResultsWrapper/AsyncResultsWrapper";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import TableBillingHistory from "./TableBillingHistory";
import { groupByWeekAndSum } from "../CommissionsHistory/utils";

export default function BillingHistory() {
  const { t } = useTranslation();
  const companyTitle = useCompanyPageTitle();
  // Filter labels are translated, so rebuild them when the language changes.
  const mobileFilters = useMemo(() => filtersMobileInputs(t), [t]);
  const desktopFilters = useMemo(() => filtersDesktopInputs(t), [t]);
  const {
    data,
    onChangeFilters,
    onChangeTypeState,
    onChangeResetFiltersState,
    haveActiveFilters
  } = useFilterState("billing");
  const {
    data: dataResults,
    resultsLength,
    loading,
    error
  } = useTransactionsPaidHistory({
    filters: data.filters
  });
  const dataToRender = groupByWeekAndSum(dataResults);

  return (
    <Box
      sx={{
        px: { xs: "16px", sm: "24px" },
        py: "48px",
        display: "flex",
        flexDirection: "column",
        gap: "24px"
      }}
    >
      <Typography
        sx={{
          ...typography.heading.xl,
          color: semanticColors.text.primary,
          textAlign: "center"
        }}
      >
        {companyTitle(t("billingHistory.title"))}
      </Typography>
      {isMobile ? (
        <FiltersMobile
          state={data}
          filters={mobileFilters}
          mobileExpanded={data.mobileExpanded}
          onChangeFilters={onChangeFilters}
          onChangeTypeState={onChangeTypeState}
          spaceItems={2}
          onChangeReset={haveActiveFilters ? onChangeResetFiltersState : null}
          resultsLength={resultsLength}
        />
      ) : (
        <FiltersDesktop
          state={data}
          filters={desktopFilters}
          onChangeFilters={onChangeFilters}
          spaceItems={3}
          onChangeReset={haveActiveFilters ? onChangeResetFiltersState : null}
          resultsLength={resultsLength}
        />
      )}
      <AsyncResultsWrapper loading={loading} error={error} data={dataToRender}>
        <TableBillingHistory data={dataToRender} />
      </AsyncResultsWrapper>
    </Box>
  );
}
